import { render, staticRenderFns } from "./_base-img-upload.vue?vue&type=template&id=33b79c52&"
import script from "./_base-img-upload.vue?vue&type=script&lang=js&"
export * from "./_base-img-upload.vue?vue&type=script&lang=js&"
import style0 from "./_base-img-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports